import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import ResultPack from "./ResultPack";
import { ArrowLeft } from "lucide-react";

export default function ReviewDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [review, setReview] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/reviews/${id}`);
        setReview(data);
      } catch (e) {
        setErr(formatApiErrorDetail(e.response?.data?.detail));
      }
    })();
  }, [id]);

  if (err) {
    return (
      <div className="max-w-[900px] mx-auto p-10">
        <button className="btn-ghost -ml-2" onClick={() => navigate("/history")}>
          <ArrowLeft className="w-4 h-4" /> Back to history
        </button>
        <div className="mt-6 text-sm text-[var(--severity-red-text)]">{err}</div>
      </div>
    );
  }
  if (!review) {
    return (
      <div className="max-w-[900px] mx-auto p-10 text-ink-50 font-mono-plex text-sm uppercase tracking-widest">
        Loading review…
      </div>
    );
  }

  return (
    <>
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 pt-8">
        <button
          className="btn-ghost focus-ring -ml-2"
          onClick={() => navigate("/history")}
          data-testid="review-back-history"
        >
          <ArrowLeft className="w-4 h-4" /> Back to history
        </button>
      </div>
      <ResultPack
        review={review}
        onReset={() => navigate("/")}
        onSaveAccount={() => {}}
        savedToAccount
      />
    </>
  );
}
